import Card from '@/components/elements/Card/Card';
import { Button } from '@/components/elements/forms/buttons';
import { ListItem } from '@/components/elements/lists';
import Icon from '@/components/icons/Icon';
import { _s } from '@/locale';

const baseTranslationKey = 'features.ProfilePages.components.OpeningHours';
const WEEKDAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
type Hours = Record<(typeof WEEKDAYS)[number], string>;

const OpeningHours = ({
  openingHours,
  showCta,
  additionalInfo,
}: {
  openingHours?: Hours;
  showCta?: boolean;
  additionalInfo?: string;
}) => {
  return (
    <Card size="lg">
      <div className="gap-xs flex flex-col">
        <h2 className="text-h-s">{_s(`${baseTranslationKey}.${openingHours ? 'title' : 'titleWithoutHours'}`)}</h2>
        {openingHours && (
          <ul>
            {WEEKDAYS.map((day) => {
              const isOpen = openingHours && openingHours[day];
              const openingHoursText = isOpen ? openingHours[day] : _s(`${baseTranslationKey}.closed`);
              return (
                <ListItem
                  key={day}
                  leftPadding={false}
                  rightPadding={false}
                  underline={day !== 'sunday'}
                  rightSlot={
                    <span className={`text-m ${isOpen ? 'text-fg_secondary' : 'text-fg_negative'}`}>
                      {openingHours ? openingHoursText : _s(`${baseTranslationKey}.missingHours`)}
                    </span>
                  }>
                  <span className="text-l text-fg_primary">{_s(day)}</span>
                </ListItem>
              );
            })}
            {additionalInfo && (
              <div className="mt-xs p-md bg-bg_secondary_neutral gap-xs flex flex-col rounded-lg">
                <h3>{_s(`${baseTranslationKey}.additionalInfo`)}</h3>
                <p className="text-m text-fg_secondary">{additionalInfo}</p>
              </div>
            )}
          </ul>
        )}
        {additionalInfo && !openingHours && <p className="text-m text-fg_secondary mt-xs">{additionalInfo}</p>}
        {!openingHours && showCta && (
          <Button
            size="md"
            label={_s(`${baseTranslationKey}.cta`)}
            iconNoFilter
            block
            rightIcon={<Icon variant="pen" color="fg_primary_inverse" />}
          />
        )}
      </div>
    </Card>
  );
};

export default OpeningHours;
